import { render, staticRenderFns } from "./addExclude.vue?vue&type=template&id=eb77d974"
import script from "./addExclude.vue?vue&type=script&lang=js"
export * from "./addExclude.vue?vue&type=script&lang=js"
import style0 from "./addExclude.vue?vue&type=style&index=0&id=eb77d974&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb77d974')) {
      api.createRecord('eb77d974', component.options)
    } else {
      api.reload('eb77d974', component.options)
    }
    module.hot.accept("./addExclude.vue?vue&type=template&id=eb77d974", function () {
      api.rerender('eb77d974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/addExclude.vue"
export default component.exports